/**
 * Canonical role bundles by subscription tier. Used by Cloud Functions (`resolveSubscriptionRoles`)
 * and the web client (`SubscriptionService.enhanceRolesForSubscriptionTier`).
 *
 * ROYALTY and IMPERIAL **must** include `BOOKER` (contact / book professionals per product matrix).
 * Keep this file the single source of truth — do not duplicate these arrays elsewhere.
 */
export type SubscriptionTierBundleKey = 'FREE' | 'NOBILITY' | 'ROYALTY' | 'IMPERIAL';

export const SUBSCRIPTION_TIER_ROLE_BUNDLES: Record<
  SubscriptionTierBundleKey,
  readonly string[]
> = {
  FREE: ['USER'],
  NOBILITY: ['USER', 'SELLER', 'PROFESSIONAL'],
  ROYALTY: ['USER', 'SELLER', 'PROFESSIONAL', 'BOOKER'],
  IMPERIAL: ['USER', 'SELLER', 'PROFESSIONAL', 'BOOKER', 'PREMIUM_SELLER'],
};

/** Roles that subscription tier changes replace (see shared/user-roles SUBSCRIPTION_TIER_STRIP_ROLES). */
export function tierBundleForTierKey(tierKey: SubscriptionTierBundleKey): readonly string[] {
  return SUBSCRIPTION_TIER_ROLE_BUNDLES[tierKey];
}

/**
 * Ensures every role in the canonical bundle for `tierKey` is present (upgrade / downgrade safe).
 */
export function mergeWithSubscriptionTierBundle(
  tierKey: SubscriptionTierBundleKey,
  roles: readonly string[]
): string[] {
  const bundle = SUBSCRIPTION_TIER_ROLE_BUNDLES[tierKey];
  return Array.from(new Set([...roles.map((r) => r.toUpperCase()), ...bundle]));
}
